/**
 * Determine if the contents of an element should be displayed based on the user's permissions and needRegistration flag.
 *
 * @param canManage user's permission to manage the element
 * @param canRead  user's permission to read the element
 * @param needRegistration flag indicating if registration is needed to view contents
 * @returns
 */
export const needRegistrationToViewContents = (
  canManage: Boolean,
  canRead: Boolean,
  needRegistration: Boolean
) => {
  if (canManage) {
    return false
  }

  if (needRegistration && !canRead) {
    return true
  }

  return false
}
